import { RecoverRequestForm } from "./request-form.form";
import { SectionStatus } from "../../../../../shared/components/web-form/web-form.objects";

export class RequestFormNavigation {
    form: RecoverRequestForm;

    sideBarElement: JQuery<HTMLElement>;
    currentSectionIndex: number;

    sectionCheckArr: number[];

    constructor(form: RecoverRequestForm) {
        this.form = form;
        this.sideBarElement = $("#request-sidebar");
    }

    initialize() {
        this.generateHtml();
        this.initializeSectionCheck();
        this.initializeReviewBtn();
    }

    private initializeReviewBtn() {
        let reviewBtn = this.sideBarElement.find(".review-submit-btn");
        reviewBtn.on("click", () => {
            if (reviewBtn.is(":disabled")) {
                return;
            }
            if (this.currentSectionIndex != -99) {
                this.form.updateReviewContent();
                let reviewSectionId = "review";
                this.navigateToSection(reviewSectionId, -99);
            }
        })
    }

    private initializeSectionCheck() {
        this.sectionCheckArr = [];
        for (let i = 0; i < this.form.formSections.length; i++) {
            this.sectionCheckArr.push(0);
        }
    }

    private updateSectionCheck(sectionIndex: number, status: SectionStatus) {
        if (this.sectionCheckArr) {
            let newStatus = 0;
            if (status == SectionStatus.Complete) {
                newStatus = 1;
            }
            this.sectionCheckArr.splice(sectionIndex, 1, newStatus);

            if (this.sectionCheckArr.every(item => item == 1)) {
                this.showSubmitBtn(true);
            }
            else {
                this.showSubmitBtn(false);
            }
        }
    }

    private showSubmitBtn(shouldShow: boolean) {
        let reviewBtn = this.sideBarElement.find(".review-submit-btn");
        reviewBtn.prop("disabled", !shouldShow);
    }

    updateSectionStatus(sectionId: string, status: SectionStatus) {
        let foundIndex = this.form.formSections.findIndex(section => section.sectionId == sectionId);
        if (foundIndex >= 0) {
            let navElement = $(`#nav-section-${foundIndex}`);
            let icon = navElement.find(".nav-section-icon");
            let newIcon = this.getIconByStatus(status);
            icon.empty().html(newIcon);

            this.updateSectionCheck(foundIndex, status);
        }
    }

    private generateHtml() {
        let formSectionHtml = "";
        for (let i = 0; i < this.form.formSections.length; i++) {
            let section = this.form.formSections[i];
            let active = "";
            if (i == 0) active = "active"

            let content = `
                <div id="nav-section-${i}" class='d-flex justify-content-between align-items-center nav-section-block ${active}'>
                    <div class='nav-section-text'>${section.displayName}</div>
                    <div class='nav-section-icon'><i class="fa-regular fa-circle fa-lg"></i></div>
                </div>
            `

            formSectionHtml += content;
        }

        let navButtonHtml = `
            <div class="mt-3 nav-section-btns d-flex align-items-center justify-content-between">
                <div>
                    <button class='btn prev-btn nav-btn' disabled><i class="fa-solid fa-chevron-left pr-2"></i>Prev</button>
                </div>
                <div>
                    <button class='btn next-btn nav-btn'>Next<i class="fa-solid fa-chevron-right pl-2"></i></button>
                </div>
            </div>
        `;

        let additionalBtnHtml = `
            <div class="mb-3" style="padding: 0 0.75rem;">
                <button class='btn review-submit-btn' disabled>Review & Submit</button>
            </div>
            <div class="mb-2" style="padding: 0 0.75rem;">
                <button class='btn save-progress-btn'><i class="fa-solid fa-floppy-disk pr-3"></i>Save</button>
            </div>
            <div class="save-form-loading d-none">
                <div class="font-size14 mb-1">Saving</div>
                <div class="pl-2">
                    <div class="spinner-border spinner-border-sm" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
            <div class="save-form-complete d-none">
                <div class="font-size14 mb-1">Saved!</div>
            </div>
        `;

        let html = `
            <div class="application-sidebar">
                ${formSectionHtml}
                ${navButtonHtml}
                <hr class='my-3'>
                ${additionalBtnHtml}
            </div>
        `;

        this.sideBarElement.empty().html(html);

        this.currentSectionIndex = 0;

        this.initializeSectionNav();
    }

    private initializeSectionNav() {
        let nav = this;
        this.sideBarElement.find(".nav-section-block").on('click', function () {
            let sectionId = <string>$(this).prop("id");
            let index = parseInt(sectionId.replace("nav-section-", ""));
            let foundSection = nav.form.formSections[index];
            if (foundSection) {
                nav.navigateToSection(foundSection.sectionId, index);
            }
        });

        let prevBtn = this.sideBarElement.find(".prev-btn");
        let nextBtn = this.sideBarElement.find(".next-btn");

        prevBtn.on('click', () => {
            if (prevBtn.is(":disabled")) {
                return;
            }
            if (this.currentSectionIndex <= 0) {
                return;
            }

            let newIndex = this.currentSectionIndex - 1;
            let foundSection = this.form.formSections[newIndex];
            if (foundSection) {
                this.navigateToSection(foundSection.sectionId, newIndex);
            }
        });

        nextBtn.on('click', () => {
            if (nextBtn.is(":disabled")) {
                return;
            }

            let maxIndex = this.form.formSections.length - 1;
            if (this.currentSectionIndex >= maxIndex) {
                return;
            }

            let newIndex = this.currentSectionIndex + 1;
            let foundSection = this.form.formSections[newIndex];
            if (foundSection) {
                this.navigateToSection(foundSection.sectionId, newIndex);
            }
        })
    }

    private navigateToSection(sectionId: string, index: number = -99) {
        this.currentSectionIndex = index;

        let foundFormSection = $(`#${sectionId}`);
        $(".form-section").addClass("d-none");
        foundFormSection.removeClass('d-none');
        this.scrollToTop();
        this.updateActiveNavBar(index);

        // Trigger Save
        this.form.triggerSave();
    }

    private updateActiveNavBar(index: number = -99) {
        this.sideBarElement.find(".nav-section-block").removeClass("active");
        if (index >= 0) {
            let navSectionId = `#nav-section-${index}`;
            $(navSectionId).addClass('active');
        };
        this.updatePrevNextBtn(index);
    }

    private updatePrevNextBtn(index: number = -99) {
        let prevBtn = this.sideBarElement.find(".prev-btn");
        let nextBtn = this.sideBarElement.find(".next-btn");

        let maxIndex = this.form.formSections.length - 1;
        if (index == -99) {
            nextBtn.prop("disabled", true);
            prevBtn.prop("disabled", true);
        }
        else if (index == 0) {
            prevBtn.prop("disabled", true);
            nextBtn.prop("disabled", false);
        }
        else if (index >= maxIndex) {
            nextBtn.prop("disabled", true);
            prevBtn.prop("disabled", false);
        }
        else {
            nextBtn.prop("disabled", false);
            prevBtn.prop("disabled", false);
        }
    }

    private scrollToTop() {
        $('html, body').animate({
            scrollTop: 0
        }, 500);
    }

    private getIconByStatus(status: SectionStatus): string {
        if (status == SectionStatus.Complete) {
            return `<i class="fa-solid fa-circle-check fa-lg green-icon"></i>`
        }
        else if (status == SectionStatus.InProgress) {
            return `<i class="fa-solid fa-circle-half-stroke fa-lg "></i>`
        }

        return `<i class="fa-regular fa-circle fa-lg"></i>`
    }
}